import { ProDriverTable } from "@/app/ProDrivers/Drivers/Components/ProDriverTable";

export function ProDriverTableScreen() {
  return <ProDriverTable id="paid-driver-list-screen" />;
}
